import queryString from "query-string";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export const useQuery = (options) => {
    const { search } = useLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => queryString.parse(search, options), [search]);
};
